import React, { useState } from "react";
import * as S from "./ModalCriarStyle";
import Loading from "../../Loader";
import { consultorService } from "../../../Services/consultorService";
import { useMessage } from "../../../Context/MessageContext"; // Assumindo que você tem um MessageContext
import {
  FaUser,
  FaIdCard,
  FaEnvelope,
  FaPhone,
  FaLock,
  FaTimes,
} from "react-icons/fa";

export default function ModalCriar({ onClose }) {
  const { showMessage } = useMessage(); // Para notificações mais elegantes
  const [formData, setFormData] = useState({
    name: "",
    cpfCnpj: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Limpa o erro do campo ao começar a digitar
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Nome é obrigatório.";
    if (!formData.cpfCnpj.trim()) newErrors.cpfCnpj = "CPF/CNPJ é obrigatório.";
    if (!formData.email.trim()) newErrors.email = "E-mail é obrigatório.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Formato de e-mail inválido.";
    if (!formData.password.trim()) newErrors.password = "Senha é obrigatória.";
    else if (formData.password.length < 8)
      newErrors.password = "A senha deve ter no mínimo 8 caracteres.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirm = async () => {
    if (!validateForm()) {
      showMessage("Por favor, corrija os campos destacados.", "error");
      return;
    }

    setLoad(true);
    try {
      await consultorService.createConsultor(formData);
      showMessage("Consultor criado com sucesso!", "success");
      onClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Houve um erro ao criar o consultor.";
      showMessage(errorMessage, "error");
      console.log(error);
    } finally {
      setLoad(false);
    }
  };

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <Loading load={load} />
        <S.ModalHeader>
          <h3>Cadastrar Novo Consultor</h3>
          <S.CloseButton onClick={onClose}>
            <FaTimes />
          </S.CloseButton>
        </S.ModalHeader>
        <S.ModalBody>
          <S.InputGrid>
            <S.InputGroup>
              <label htmlFor="name">Nome Completo</label>
              <div className="input-wrapper">
                <FaUser />
                <input
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Nome do Consultor"
                />
              </div>
              {errors.name && <S.ErrorMessage>{errors.name}</S.ErrorMessage>}
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="cpfCnpj">CPF ou CNPJ</label>
              <div className="input-wrapper">
                <FaIdCard />
                <input
                  id="cpfCnpj"
                  name="cpfCnpj"
                  value={formData.cpfCnpj}
                  onChange={handleInputChange}
                  placeholder="Apenas números"
                />
              </div>
              {errors.cpfCnpj && (
                <S.ErrorMessage>{errors.cpfCnpj}</S.ErrorMessage>
              )}
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="email">Email</label>
              <div className="input-wrapper">
                <FaEnvelope />
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="exemplo@email.com"
                />
              </div>
              {errors.email && <S.ErrorMessage>{errors.email}</S.ErrorMessage>}
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="phoneNumber">Telefone</label>
              <div className="input-wrapper">
                <FaPhone />
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  placeholder="(XX) XXXXX-XXXX"
                />
              </div>
            </S.InputGroup>

            <S.InputGroup className="full-width">
              <label htmlFor="password">Senha de Acesso</label>
              <div className="input-wrapper">
                <FaLock />
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Mínimo 8 caracteres"
                />
              </div>
              {errors.password && (
                <S.ErrorMessage>{errors.password}</S.ErrorMessage>
              )}
            </S.InputGroup>
          </S.InputGrid>
        </S.ModalBody>
        <S.ModalFooter>
          <S.CancelButton onClick={onClose}>Cancelar</S.CancelButton>
          <S.ConfirmButton onClick={handleConfirm}>
            Confirmar Cadastro
          </S.ConfirmButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
